import { render, staticRenderFns } from "./BaseInputTime.vue?vue&type=template&id=c80d2d6c&"
import script from "./BaseInputTime.vue?vue&type=script&lang=js&"
export * from "./BaseInputTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports